import { render } from "./Output.vue?vue&type=template&id=021f87bc&ts=true"
import script from "./Output.vue?vue&type=script&lang=ts"
export * from "./Output.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\vue_workspace\\gokou-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__